<template>
  <div class="search-container w-100" :class="{ '_ml-10 _mr-6': searchOpened }">
    <div
      @click="dataLayerPush()"
      class="search d-none d-xl-flex justify-end align-center _mr-6"
      v-if="!searchOpened"
    >
      <div class="search__icon d-flex justify-center align-center _mr-2">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="8" stroke="white" stroke-width="2" />
          <path
            d="M21.2929 22.7071C21.6834 23.0976 22.3166 23.0976 22.7071 22.7071C23.0976 22.3166 23.0976 21.6834 22.7071 21.2929L21.2929 22.7071ZM16.7071 15.2929C16.3166 14.9024 15.6834 14.9024 15.2929 15.2929C14.9024 15.6834 14.9024 16.3166 15.2929 16.7071L16.7071 15.2929ZM22.7071 21.2929L16.7071 15.2929L15.2929 16.7071L21.2929 22.7071L22.7071 21.2929Z"
            fill="white"
          />
        </svg>
      </div>
      <div class="search__text _fs-16 _fw-500">
        {{ $t("interface.search") }}
      </div>
    </div>
    <div class="header__search-input-container d-none d-xl-flex" v-else>
      <div class="header__search-input">
        <div class="header__search">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="10.5"
              cy="10.4999"
              r="6"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="square"
            />
            <path
              d="M15 14.9999L19.5 19.4999"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="square"
            />
          </svg>
        </div>
        <input
          type="text"
          autocomplete="new-password"
          v-model="search"
          :placeholder="$t('interface.search_placeholder')"
        />
        <div
          class="header__search-results"
          v-if="searchResults && searchResults.length"
        >
          <router-link
            :to="toSearchResult(res)"
            class="header__search-result"
            v-html="res.title"
            v-for="(res, ind) in searchResults"
            :key="ind"
          ></router-link>
        </div>
      </div>
      <div class="header__search-close" @click="closeSearch()">
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M5.25 5.25L18.75 18.75"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="square"
          />
          <path
            d="M18.75 5.25L5.25 18.75"
            stroke="currentColor"
            stroke-width="1.5"
            stroke-linecap="square"
          />
        </svg>
      </div>
    </div>
    <div class="d-xl-none" v-if="!searchOpened">
      <div class="search_mobile">
        <div class="search__container">
          <input
            :placeholder="$t('interface.search')"
            class="search__input"
            type="text"
            autocomplete="new-password"
            v-model="search"
          />
          <AppBtn :btnClass="'btn_primary _pa-0 _br--8'">
            <span class="_pa-2">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="10" cy="10" r="8" stroke="white" stroke-width="2" />
                <path
                  d="M21.2929 22.7071C21.6834 23.0976 22.3166 23.0976 22.7071 22.7071C23.0976 22.3166 23.0976 21.6834 22.7071 21.2929L21.2929 22.7071ZM16.7071 15.2929C16.3166 14.9024 15.6834 14.9024 15.2929 15.2929C14.9024 15.6834 14.9024 16.3166 15.2929 16.7071L16.7071 15.2929ZM22.7071 21.2929L16.7071 15.2929L15.2929 16.7071L21.2929 22.7071L22.7071 21.2929Z"
                  fill="white"
                />
              </svg> </span
          ></AppBtn>
          <div
            class="header__search-results"
            v-if="searchResults && searchResults.length"
          >
            <router-link
              :to="toSearchResult(res)"
              class="header__search-result"
              v-html="res.title"
              v-for="(res, ind) in searchResults"
              :key="ind"
            ></router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppBtn from "../../components/UI/buttons/AppBtn.vue";
export default {
  components: { AppBtn },
  name: "AppSearch",
  data: () => ({
    search: "",
    searchOpened: false,
  }),
  computed: {
    ...mapGetters(["searchResults"]),
    currentLocale() {
      return this.Trans.currentLocale;
    },
  },
  methods: {
    ...mapActions(["fetchSearch", "clearSearch"]),
    closeSearch() {
      this.search = "";
      this.searchOpened = false;
      this.clearSearch();
    },
    dataLayerPush() {
      this.searchOpened = true;
      if (this.$gtm) {
        this.$gtm.push({
          event: "ev_search",
        });
      }
    },
    toSearchResult(res) {
      switch (res.type) {
        case "intensive":
          return {
            name: "Intensive",
            params: { slug: res.slug },
          };
        case "intensive_lesson":
          return {
            name: "Intensive",
            params: { slug: res.parent_slug },
          };
        case "hn_grow":
          return { name: "HNGrow" };
        case "academy":
          if (res.parent_slug) {
            return {
              name: "SuccessAcademySections",
              params: { slug: res.parent_slug },
            };
          } else {
            return { name: "SuccessAcademy" };
          }
        case "academy_element":
          return {
            name: "SuccessAcademySections",
            params: { slug: res.parent_slug },
          };
        case "screencast":
          return { name: "Screencast", params: { slug: res.parent_slug } };
        case "webinar":
          return { name: "Webinars" };
        case "training":
          if (res.access_groups.length) {
            return { name: "Qualification" };
          } else {
            return { name: "Trainings" };
          }

        case "system":
          return { name: "System" };
        case "success_wall":
          return {
            name: "SuccessPerson",
            params: { categoryID: res.category_id, id: res.person_id },
          };
        default:
          return "#";
      }
    },
  },
  watch: {
    async search() {
      if (this.search.length > 2) {
        this.fetchSearch({ q: this.search, lang: this.currentLocale });
      } else {
        this.clearSearch();
      }
    },
    "$route.path": {
      handler: async function () {
        this.clearSearch();
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.search__icon {
  width: 38px;
  height: 38px;
  border-radius: 16px;
  background-color: color(green-main);
  cursor: pointer;
}

.search__text {
  color: color(grey-light);
  cursor: pointer;
}

.header__search {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #ebefee;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #77bb2f;
  transition: 0.3s;
  cursor: pointer;

  &:hover {
    background-color: #d8dfde;
  }

  &-results {
    padding: 16px;
    position: absolute;
    top: calc(100% + 10px);
    left: 0;
    width: 100%;
    z-index: 2;
    background-color: #fff;
    box-shadow: 0px 0px 4px 2px rgba(184, 184, 184, 0.47);
    border-radius: 8px;
    max-height: 500px;
    overflow-y: auto;

    @media screen and (max-width: 1220px) {
      box-shadow: none;
      padding: 16px;
      top: 90px;
      height: calc(100% - 200px);
      overflow-y: auto;
      z-index: 3;
    }
  }

  &-result {
    display: block;
    padding: 12px;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;
    color: #b2b4b4;
    transition: 0.3s;
    border-radius: 8px;
    cursor: pointer;

    &:hover {
      background-color: #ebf6e3;
    }

    @media screen and (max-width: 743px) {
      padding: 0;
      margin-bottom: 16px;

      &:hover {
        background-color: transparent;
        color: #b2b4b4;
      }
    }
  }

  &-close {
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin-left: 16px;
    color: #b2b4b2;
    transition: 0.3s;

    &:hover {
      color: #77bb2f;
    }
  }

  &-input-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    .header__search {
      flex-shrink: 0;
      &:hover {
        background-color: #ebefee;
      }
    }

    @media screen and (max-width: 743px) {
      height: auto;
      padding: 0;
    }
  }

  &-input {
    position: relative;
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
    background-color: #ebefee;
    border-radius: 999px;

    & > input {
      width: 100%;
      background-color: transparent;
      border: 0;
      outline: none;
      font-family: "Helvetica Neue", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 21px;
      color: #000;
    }
  }
}

.search_mobile {
  .search {
    &__container {
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      border: 1px solid #d1d2cd;
      border-radius: 16px;
      padding: 8px 16px;
    }

    &__input {
      width: 100%;
      border: 0;
      padding: 0;
      font-family: "Noto-Sans", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      outline: 0;

      &::placeholder,
      &:-ms-input-placeholder,
      &::-ms-input-placeholder {
        /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #b2b4b4;
        opacity: 1; /* Firefox */
      }
    }
  }
}
</style>

<style>
.header__search-result > * {
  color: #77bb2f;
}
</style>
